import { Component, Input, OnInit } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { FacReportObject } from 'app/shared/models/report-objects';
import { DateFormatPipe } from 'app/pipes/date-format.pipe';
import { TranslationService, Language } from 'app/shared/services/translation.service';

@Component({
  selector: 'fac-report-widget',
  templateUrl: './fac-report-widget.component.html',
  styleUrls: ['./fac-report-widget.component.scss'],
  animations: fuseAnimations,
})

export class FacReportWidgetComponent implements OnInit {
  @Input() jsonData: any;
  @Input() language: Language;
  @Input() showTranslation: boolean;

  reportDetails: any;
  facReportObject: FacReportObject;

  dateFormat: DateFormatPipe;

  constructor(public translationService: TranslationService) { }

  ngOnInit(): void {
    if (this.jsonData) {
      this.reportDetails = this.jsonData;
      this.facReportObject = this.reportDetails as FacReportObject;
    }
  }

  get AnonymityStatus(): string{
    if (this.facReportObject){
      if (this.facReportObject.anonymous === false){ return 'Confidential';}
      if (this.facReportObject.anonymous === true){ return 'Anonymous';}
    }
    return '';
  }
}